﻿const validationSummaryErrors = document.querySelector('.validation-summary-errors');
if (validationSummaryErrors) {
    window.scrollTo(0, validationSummaryErrors['offsetTop']);
}

const label: HTMLLabelElement | null = document.querySelector('label[for="Agreement1"]');
if (label) {
    label.style.flexBasis = "50%";
    label.style.flexGrow = "1";
};
